export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const casinoTabs = {
  colorprediction: {
    D5Lottery1: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-5d-lottery-1",
      code: "",
      casino: "Mac88 Gaming Virtual",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/colorprediction/5DLotto.webp",
      alt: "5D Lottery 1",
      name: "5D Lottery 1",
    },
    Wingo: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-wingo",
      code: "",
      casino: "Mac88 Gaming Virtual",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/colorprediction/Wingo.webp",
      alt: "Wingo",
      name: "Wingo",
    },
    k3lottery1: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-k3-lottery-1",
      code: "",
      casino: "Mac88 Gaming Virtual",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/colorprediction/K3Lottery1.webp",
      alt: "K3 Lottery 1",
      name: "K3 Lottery 1",
    },
    ColorGameMidas: {
      redirectUrl: "/casino/km-color-game",
      code: "",
      casino: "Kingmidas Gaming",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/colorprediction/ColorGameKingmidas.webp",
      alt: "Color Game Kingmidas",
      name: "Color Game Kingmidas",
    },
    ColorGameJili: {
      redirectUrl: "/casino/aggapjiligaming-color-game",
      code: "",
      casino: "JiLi Gaming",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/colorprediction/ColorGameJili.webp",
      alt: "Color Game Jili",
      name: "Color Game Jili",
    },
    ColorPrediction: {
      redirectUrl: "/casino/aggapjiligaming-color-prediction",
      code: "",
      casino: "JiLi Gaming",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/colorprediction/ColorPrediction.webp",
      alt: "Color Prediction",
      name: "Color Prediction",
    },
    ColorGameSN: {
      redirectUrl: "/casino/sn-color-game",
      code: "",
      casino: "Supernowa",
      provider: "WorldCasino",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/colorprediction/ColorGameSN.webp",
      alt: "Color Game Supernowa",
      name: "Color Game Supernowa",
    },
    ColorGameRICH88: {
      redirectUrl: "/casino/aggaprich88-color-game",
      code: "",
      casino: "RICH88",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/colorprediction/ColorGamerich88.webp",
      alt: "Color Game RICH88",
      name: "Color Game RICH88",
    },
  },
  popular: {
    OneDayTeenPattiPR: {
      redirectUrl: "/casino/ezg-one-day-teen-patti",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/onedayteenpatti.webp",
      alt: "one day teen patti",
      name: "One Day Teen Patti",
    },
    AviatorPR: {
      redirectUrl: "/casino/spribe-aviator",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/aviator.webp",
      alt: "aviator",
      name: "Aviator",
    },
    AndarBaharLivePR: {
      redirectUrl: "/casino/ezg-andar-bahar",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/andarbahar.webp",
      alt: "andar bahar live",
      name: "Andar Bahar Lve",
    },
    Cards32PR: {
      redirectUrl: "/casino/ezg-32-cards",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/32cards.webp",
      alt: "32 cards",
      name: "32 Cards",
    },
    Victorious: {
      redirectUrl: "/casino/ezgne-victorious",
      code: "1100123                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/Victorious.webp",
      alt: "",
      name: "Victorious",
      providerName: "NetEnt",
    },
    Warlords: {
      redirectUrl: "/casino/ezgne-warlords-crystal-of-power",
      code: "1100125                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/warlords.webp",
      alt: "",
      name: "Warlords: Crystal of Power",
      providerName: "NetEnt",
    },
    WildWater: {
      redirectUrl: "/casino/ezgne-wild-water",
      code: "1100126                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/WildWater.webp",
      alt: "",
      name: "Wild Water",
      providerName: "NetEnt",
    },
    WildWorlds: {
      redirectUrl: "/casino/ezgne-wild-worlds",
      code: "1100127                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/wildworlds.webp",
      alt: "",
      name: "Wild Worlds",
      providerName: "NetEnt",
    },
    Squad4: {
      redirectUrl: "/casino/ezgrt-4-squad",
      code: "1100129                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/Squad4.webp",
      alt: "",
      name: "4 Squad",
      providerName: "Red Tiger",
    },
    Families5: {
      redirectUrl: "/casino/ezgrt-5-families",
      code: "1100130                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/families5.webp",
      alt: "",
      name: "5 Families",
      providerName: "Red Tiger",
    },
    AgentRoyale: {
      redirectUrl: "/casino/ezgrt-agent-royale",
      code: "1100131                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/AgentRoyale.webp",
      alt: "",
      name: "Agent Royale",
      providerName: "Red Tiger",
    },
    ArcadeBomb: {
      redirectUrl: "/casino/ezgrt-arcade-bomb",
      code: "1100132                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/arcadebomb.webp",
      alt: "",
      name: "Arcade Bomb",
      providerName: "Red Tiger",
    },
    Atlantis: {
      redirectUrl: "/casino/ezgrt-atlantis",
      code: "1100133                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/Atlantis.webp",
      alt: "",
      name: "Atlantis",
      providerName: "Red Tiger",
    },
    CrazyTimePR: {
      redirectUrl: "/casino/ezgevo-crazy-time",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/crazytime.webp",
      alt: "crazy time",
      name: "Crazy Time",
    },

    DragonTiger1PR: {
      redirectUrl: "/casino/ezg-dragon-tiger",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/dragontiger.webp",
      alt: "dragon tiger 1",
      name: "Dragon Tiger 1",
    },
    ItalianRoulettePR: {
      redirectUrl: "/casino/ezg-italian-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/italianroulette.webp",
      alt: "italian roulette",
      name: "Italian Roulette",
    },
    Lucky7PR: {
      redirectUrl: "/casino/ezg-lucky-7",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/lucky7.webp",
      alt: "seven lucky",
      name: "Seven Lucky",
    },
  },
  exclusive: {
    UltimateRouletteEZ: {
      redirectUrl: "/casino/ezg-ultimate-roulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/UltimateRouletteEZ.webp",
      alt: "ultimate roulette",
      name: "Ultimate Roulette",
    },
    DiamondRouletteEZ: {
      redirectUrl: "/casino/ezg-diamond-roulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/DiamondRouletteEZ.webp",
      alt: "diamond roulette",
      name: "Diamond Roulette",
    },
    NamasteRouletteEZ: {
      redirectUrl: "/casino/ezg-namaste-roulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/NamasteRouletteEZ.webp",
      alt: "namaste roulette",
      name: "Namaste Roulette",
    },
    AutoRouletteEZ: {
      redirectUrl: "/casino/ezg-auto-roulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/AutoRouletteEZ.webp",
      alt: "auto roulette",
      name: "Auto Roulette",
    },
    SpeedAutoRouletteEZ: {
      redirectUrl: "/casino/ezg-speed-auto-roulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/SpeedAutoRouletteEZ.webp",
      alt: "speed auto roulette",
      name: "Speed Auto Roulette",
    },
    OracleRoulette2EZ: {
      redirectUrl: "/casino/ezg-oracle-roulette-2",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/OracleRoulette2EZ.webp",
      alt: "oracle roulette 2",
      name: "Oracle Roulette 2",
    },
    ItalianRouletteEZ: {
      redirectUrl: "/casino/ezg-italian-roulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/ItalianRouletteEZ.webp",
      alt: "italian roulette",
      name: "Italian Roulette",
    },
    SpanishRouletteEZ: {
      redirectUrl: "/casino/ezg-spanish-roulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/SpanishRouletteEZ.webp",
      alt: "spanish roulette",
      name: "Spanish Roulette",
    },

    DragonTigerEvo: {
      redirectUrl: "/casino/ezgevo-dragon-tiger-evo",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/DragonTigerEvo.webp",
      alt: "dragon tiger evo",
      name: "Dragon Tiger Evo",
    },
    BaccaratAEvo: {
      redirectUrl: "/casino/ezgevo-baccarat-a",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/BaccaratAEvo.webp",
      alt: "baccarat a",
      name: "Baccarat A",
    },
    BlackjackAEvo: {
      redirectUrl: "/casino/ezgevo-blackjack-a",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/BlackjackAEvo.webp",
      alt: "blackjack a",
      name: "Blackjack A",
    },
    CrazyTimeEvo: {
      redirectUrl: "/casino/ezgevo-crazy-time",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/CrazyTimeEvo.webp",
      alt: "crazy time",
      name: "Crazy Time",
    },
    MegaballEvo: {
      redirectUrl: "/casino/ezgevo-mega-ball",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/megaball.webp",
      alt: "megaball",
      name: "Megaball",
    },
    SuperSicBoEvo: {
      redirectUrl: "/casino/ezgevo-super-sic-bo",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/SuperSicBoEvo.webp",
      alt: "super sic bo",
      name: "Super Sic Bo",
    },
    Poker: {
      code: "67564",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poker",
      name: "Poker",
      providerName: "aura",
      imgUrl: "./images/aura/Poker.webp",
      redirectUrl: "/casino/aura-poker",
    },
    SuperOver: {
      code: "67720",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Over",
      name: "Super Over",
      providerName: "aura",
      imgUrl: "./images/aura/SuperOver.webp",
      redirectUrl: "/casino/aura-sper-over",
    },
    Matka: {
      code: "92037",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Matka",
      name: "Matka",
      providerName: "aura",
      imgUrl: "./images/aura/Matka.webp",
      redirectUrl: "/casino/aura-matka",
    },
    Baccarat: {
      code: "92038",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat",
      name: "Baccarat",
      providerName: "aura",
      imgUrl: "./images/aura/Baccarat-new.webp",
      redirectUrl: "/casino/aura-baccarat",
    },
    Trio: {
      code: "67610",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Trio",
      name: "Trio",
      providerName: "aura",
      imgUrl: "./images/aura/Trio-new.webp",
      redirectUrl: "/casino/aura-trio",
    },
    CardsJudgement3: {
      code: "67670",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Cards Judgement",
      name: "3 Cards Judgement",
      providerName: "aura",
      imgUrl: "./images/aura/3CardJudgement.jpg",
      redirectUrl: "/casino/aura-3-cards-judgement",
    },
    Race2020: {
      code: "90100",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Race 20-20",
      name: "Race 20-20",
      providerName: "aura",
      imgUrl: "./images/aura/Race20-20.webp",
      redirectUrl: "/casino/aura-race-20-20",
    },
    CardBaccarat29: {
      code: "67690",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "29 Card Baccarat",
      name: "29 Card Baccarat",
      providerName: "aura",
      imgUrl: "./images/aura/CardBaccarat29.webp",
      redirectUrl: "/casino/aura-29-card-baccarat",
    },
    TeenpattiOpen: {
      code: "67640",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti Open",
      name: "Teenpatti Open",
      providerName: "aura",
      imgUrl: "./images/aura/teenpaatiopen.webp",
      redirectUrl: "/casino/aura-teenpatti-open",
    },
    Raceto17: {
      code: "67710",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Race to 17",
      name: "Race to 17",
      providerName: "aura",
      imgUrl: "./images/aura/Raceto17.webp",
      redirectUrl: "/casino/aura-race-to-17",
    },
    Sixplayerpoker: {
      code: "67565",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Six player poker",
      name: "Six player poker",
      providerName: "aura",
      imgUrl: "./images/aura/Sixplayerpoker.webp",
      redirectUrl: "/casino/aura-six-player-poker",
    },
    CasinoMeter: {
      code: "67575",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Casino Meter",
      name: "Casino Meter",
      providerName: "aura",
      imgUrl: "./images/aura/CasinoMeter.webp",
      redirectUrl: "/casino/aura-casino-meter",
    },
    TheTrap: {
      code: "67680",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Trap",
      name: "The Trap",
      providerName: "aura",
      imgUrl: "./images/aura/TheTrap-Aura.webp",
      redirectUrl: "/casino/aura-the-trap",
    },
  },
  ezugi: {
    // UltimateRouletteEZ: {
    //   redirectUrl: "/casino/ezg-ultimate-roulette",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "Ezugi",
    //   homeUrl: pageUrlGenerator("/home"),
    //   imgUrl: "./images/casino/ezugi/Speed-Roulette1.png",
    //   alt: "ultimate roulette",
    //   name: "Ultimate Roulette",
    // },
    // DiamondRouletteEZ: {
    //   redirectUrl: "/casino/ezugi/DiamondRoulette",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "Ezugi",
    //   homeUrl: pageUrlGenerator("/home"),
    //   imgUrl: "./images/casino/ezugi/Diamond-roulette1.png",
    //   alt: "diamond roulette",
    //   name: "Diamond Roulette",
    // },
    // NamasteRouletteEZ: {
    //   redirectUrl: "/casino/ezugi/NamasteRoulette",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "Ezugi",
    //   homeUrl: pageUrlGenerator("/home"),
    //   imgUrl: "./images/casino/ezugi/Namaste-roulette1.png",
    //   alt: "namaste roulette",
    //   name: "Namaste Roulette",
    // },
    AutoRouletteEZ: {
      redirectUrl: "/casino/ezg-auto-roulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/Auto-roulette.png",
      alt: "auto roulette",
      name: "Auto Roulette",
    },
    SpeedAutoRouletteEZ: {
      redirectUrl: "/casino/ezg-speed-auto-roulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/Speed-auto-roulette.png",
      alt: "speed auto roulette",
      name: "Speed Auto Roulette",
    },
    OracleRoulette2EZ: {
      redirectUrl: "/casino/ezg-oracle-roulette-2",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/Oracle-360-roulette.png",
      alt: "oracle roulette 2",
      name: "Oracle Roulette 2",
    },
    ItalianRouletteEZ: {
      redirectUrl: "/casino/ezg-italian-roulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/Italian-roulette1.png",
      alt: "italian roulette",
      name: "Italian Roulette",
    },
    SpanishRouletteEZ: {
      redirectUrl: "/casino/ezg-spanish-roulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/Spanish-roulette.png",
      alt: "spanish roulette",
      name: "Spanish Roulette",
    },
  },
  evolution: {
    BaccaratAEvo: {
      redirectUrl: "/casino/ezgevo-baccarat-a",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/Baccart.png",
      alt: "baccarat a",
      name: "Baccarat A",
    },
    BlackjackAEvo: {
      redirectUrl: "/casino/ezgevo-blackjack-a",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/Blackjack.png",
      alt: "blackjack a",
      name: "Blackjack A",
    },
    CrazyTimeEvo: {
      redirectUrl: "/casino/ezgevo-crazy-time",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/CrazyTime.png",
      alt: "crazy time",
      name: "Crazy Time",
    },
    MegaballEvo: {
      redirectUrl: "/casino/ezgevo-mega-ball",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/Megaball.png",
      alt: "megaball",
      name: "Megaball",
    },
    SuperSicBoEvo: {
      redirectUrl: "/casino/ezgevo-super-sic-bo",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/Supersicbo.png",
      alt: "super sic bo",
      name: "Super Sic Bo",
    },
  },
  spribe: {
    mines: {
      redirectUrl: "/casino/spribe/mines",
      code: "mines",
      casino: "spribe",
      provider: "mines",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/spribe/Mines.webp",
      alt: "mines",
      name: "Mines",
    },
    goal: {
      redirectUrl: "/casino/spribe/goal",
      code: "goal",
      casino: "spribe",
      provider: "goal",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/spribe/Goal.webp",
      alt: "goal",
      name: "Goal",
    },
    dice: {
      redirectUrl: "/casino/spribe/dice",
      code: "dice",
      casino: "spribe",
      provider: "dice",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/spribe/Dice.webp",
      alt: "dice",
      name: "Dice",
    },
    aviator: {
      redirectUrl: "/casino/spribe-aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/spribe/Aviator.webp",
      alt: "aviator",
      name: "Aviator",
    },
    plinko: {
      redirectUrl: "/casino/spribe/plinko",
      code: "plinko",
      casino: "spribe",
      provider: "plinko",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/spribe/Plinko.webp",
      alt: "plinko",
      name: "Plinko",
    },
    miniroulette: {
      redirectUrl: "/casino/spribe/miniroulette",
      code: "miniroulette",
      casino: "spribe",
      provider: "miniroulette",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/spribe/miniroulette.webp",
      alt: "mini roulette",
      name: "Mini Roulette",
    },
    hilo: {
      redirectUrl: "/casino/spribe/hilo",
      code: "hilo",
      casino: "spribe",
      provider: "hilo",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/spribe/hilo.webp",
      alt: "hilo",
      name: "Hilo",
    },
    Blastoff: {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blastoff",
      name: "Blastoff",
      providerName: "aura",
      imgUrl: "./images/spribe/Blast-off.webp",
      redirectUrl: "/casino/aura-blastoff",
    },
    FortuneWheel: {
      code: "70001",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Wheel",
      name: "Fortune Wheel",
      providerName: "aura",
      imgUrl: "./images/spribe/FortumeWheel.webp",
      redirectUrl: "/casino/aura-fortune-wheel",
    },
    CoinToss: {
      code: "70003",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Coin Toss",
      name: "Coin Toss",
      providerName: "aura",
      imgUrl: "./images/spribe/cointoss.webp",
      redirectUrl: "/casino/aura-coin-toss",
    },
  },
  aura: {
    BaccaratAura: {
      redirectUrl: "/casino/aura-baccarat",
      code: "",
      casino: "Aura Gaming",
      provider: "Aura",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/aura/Baccarat-Aura.webp",
      alt: "baccarat",
      name: "Baccarat",
    },
    DreamCatcherAura: {
      redirectUrl: "/casino/aura-dream-catcher",
      code: "",
      casino: "Aura Gaming",
      provider: "Aura",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/aura/dreamcatcher-Aura.webp",
      alt: "dream catcher",
      name: "Dream Catcher",
    },
    HiLowAura: {
      redirectUrl: "/casino/aura-hi-low",
      code: "",
      casino: "Aura Gaming",
      provider: "Aura",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/aura/hilow-Aura.webp",
      alt: "hi low",
      name: "Hi Low",
    },
    MatkaAura: {
      redirectUrl: "/casino/aura-matka",
      code: "",
      casino: "Aura Gaming",
      provider: "Aura",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/aura/Matka-Aura.webp",
      alt: "matka",
      name: "Matka",
    },
    // TeenpattiOpenAura: {
    //   redirectUrl: "/casino/aura-teenpatti-open",
    //   code: "",
    //   casino: "Aura Gaming",
    //   provider: "Aura",
    //   homeUrl: pageUrlGenerator("/home"),
    //   imgUrl: "./images/aura/OpenTeenPatti.webp",
    //   alt: "teenpatti open",
    //   name: "Teenpatti Open",
    // },
    Race2020Aura: {
      redirectUrl: "/casino/aura-race-20-20",
      code: "",
      casino: "Aura Gaming",
      provider: "Aura",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/aura/RaceAura2020.webp",
      alt: "race 20 20",
      name: "Race 20 20",
    },
    TrioAura: {
      redirectUrl: "/casino/aura-trio",
      code: "",
      casino: "Aura Gaming",
      provider: "Aura",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/aura/Trio-new-Aura.webp",
      alt: "trio",
      name: "Trio",
    },
    TeenpattiT20: {
      code: "56768",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti T20",
      name: "Teenpatti T20",
      providerName: "aura",
      imgUrl: "./images/aura/TeenpattiT20-Aura.webp",
      redirectUrl: "/casino/aura-teenpatti-t20",
    },
    DragonTigerAurA: {
      code: "98790",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
      providerName: "aura",
      imgUrl: "./images/aura/Dragon-Tiger-Aura.webp",
      redirectUrl: "/casino/aura-dragon-tiger",
    },
    Poker: {
      code: "67564",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poker",
      name: "Poker",
      providerName: "aura",
      imgUrl: "./images/aura/Poker-Aura.webp",
      redirectUrl: "/casino/aura-poker",
    },
    SuperOver: {
      code: "67720",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Over",
      name: "Super Over",
      providerName: "aura",
      imgUrl: "./images/aura/SuperOver-Aura.webp",
      redirectUrl: "/casino/aura-sper-over",
    },
    Matka: {
      code: "92037",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Matka",
      name: "Matka",
      providerName: "aura",
      imgUrl: "./images/aura/Matka-Aura.webp",
      redirectUrl: "/casino/aura-matka",
    },
    Baccarat: {
      code: "92038",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat",
      name: "Baccarat",
      providerName: "aura",
      imgUrl: "./images/aura/Baccarat-Aura.webp",
      redirectUrl: "/casino/aura-baccarat",
    },
    Trio: {
      code: "67610",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Trio",
      name: "Trio",
      providerName: "aura",
      imgUrl: "./images/aura/Trio-new-Aura.webp",
      redirectUrl: "/casino/aura-trio",
    },
    CardsJudgement3: {
      code: "67670",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Cards Judgement",
      name: "3 Cards Judgement",
      providerName: "aura",
      imgUrl: "./images/aura/3CardJudgement-Aura.webp",
      redirectUrl: "/casino/aura-3-cards-judgement",
    },
    Race2020: {
      code: "90100",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Race 20-20",
      name: "Race 20-20",
      providerName: "aura",
      imgUrl: "./images/aura/Race20-20-Aura.webp",
      redirectUrl: "/casino/aura-race-20-20",
    },
    CardBaccarat29: {
      code: "67690",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "29 Card Baccarat",
      name: "29 Card Baccarat",
      providerName: "aura",
      imgUrl: "./images/aura/CardBaccarat29-Aura.webp",
      redirectUrl: "/casino/aura-29-card-baccarat",
    },
    TeenpattiOpen: {
      code: "67640",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti Open",
      name: "Teenpatti Open",
      providerName: "aura",
      imgUrl: "./images/aura/teenpaatiopen-Aura.webp",
      redirectUrl: "/casino/aura-teenpatti-open",
    },
    Raceto17: {
      code: "67710",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Race to 17",
      name: "Race to 17",
      providerName: "aura",
      imgUrl: "./images/aura/Raceto17-Aura.webp",
      redirectUrl: "/casino/aura-race-to-17",
    },
    Sixplayerpoker: {
      code: "67565",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Six player poker",
      name: "Six player poker",
      providerName: "aura",
      imgUrl: "./images/aura/Sixplayerpoker-Aura.webp",
      redirectUrl: "/casino/aura-six-player-poker",
    },
    CasinoMeter: {
      code: "67575",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Casino Meter",
      name: "Casino Meter",
      providerName: "aura",
      imgUrl: "./images/aura/CasinoMeter-Aura.webp",
      redirectUrl: "/casino/aura-casino-meter",
    },
    TheTrap: {
      code: "67680",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Trap",
      name: "The Trap",
      providerName: "aura",
      imgUrl: "./images/aura/TheTrap-Aura.webp",
      redirectUrl: "/casino/aura-the-trap",
    },
  },
  sports: {
    InplayCricket: {
      redirectUrl: "/exchange/Cricket",
      code: "",
      casino: "",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/sports/In-play.png",
      alt: "inplay",
      name: "Inplay",
    },
    Cricket: {
      redirectUrl: "/exchange/Cricket",
      code: "",
      casino: "",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/sports/cricket.png",
      alt: "cricket",
      name: "Cricket",
    },
    Soccer: {
      redirectUrl: "/exchange/Soccer",
      code: "",
      casino: "",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/sports/Soccer.png",
      alt: "soccer",
      name: "Soccer",
    },
    Tennis: {
      redirectUrl: "/exchange/Tennis",
      code: "",
      casino: "",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/sports/Tennis.png",
      alt: "tennis",
      name: "Tennis",
    },
    InplayCricket2: {
      redirectUrl: "/exchange/Cricket",
      code: "",
      casino: "",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/sports/In-play.png",
      alt: "inplay",
      name: "Inplay",
    },
    Cricket2: {
      redirectUrl: "/exchange/Cricket",
      code: "",
      casino: "",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/sports/cricket.png",
      alt: "cricket",
      name: "Cricket",
    },
    Soccer2: {
      redirectUrl: "/exchange/Soccer",
      code: "",
      casino: "",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/sports/Soccer.png",
      alt: "soccer",
      name: "Soccer",
    },
    Tennis2: {
      redirectUrl: "/exchange/Tennis",
      code: "",
      casino: "",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/sports/Tennis.png",
      alt: "tennis",
      name: "Tennis",
    },
  },
  providers: {
    ezugi: {
      redirectUrl: "/casino/ezugi",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/providers/Ezugi.jpg",
      name: "Ezugi",
      quotes:
        "Experience the excitement at Ezugi Casino, where every game is live and thrilling. Join us to enjoy real-time action and endless opportunities for big wins!",
    },
    evolution: {
      redirectUrl: "/casino/evolution",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/providers/Evolution.jpg",
      name: "Evolution",
      quotes:
        "Join Evolution Casino for an unmatched gaming experience where innovation meets excitement. Every game is a new opportunity, and every win evolves your adventure!",
    },
    vivo: {
      redirectUrl: "/casino/vivo",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/providers/vivo.jpg",
      name: "Vivo",
      quotes:
        "Experience the ultimate thrill at Vivo Gaming Casino, where cutting-edge technology meets unparalleled excitement. Play now and turn every game into a winning adventure!",
    },
    qtech: {
      redirectUrl: "/casino/qtech",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/providers/Qtech.jpg",
      name: "Qtech",
      quotes:
        "Discover the future of gaming at QTech Casino, where innovation and excitement meet. Dive into a world of thrilling games and endless opportunities for big wins!",
    },
    supernowa: {
      redirectUrl: "/casino/supernowa",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/providers/Supernowa.jpg",
      name: "Supernowa",
      quotes:
        "Unleash your winning potential at Supernowa Casino, where every game shines bright with excitement and every spin brings you closer to extraordinary rewards!",
    },
    xpg: {
      redirectUrl: "/casino/xpg",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/providers/XPG.jpg",
      name: "XPG",
      quotes:
        "Step into the world of XPG Casino, where cutting-edge gaming meets unmatched excitement. Every game is a new adventure, and every win brings you closer to greatness!",
    },
    worldcasino: {
      redirectUrl: "/casino/worldcasino",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/providers/WorldCasino.jpg",
      name: "World Casino",
      quotes:
        "Discover endless excitement at World Casino, where every game is a journey to big wins and unforgettable moments. Join us and make your mark on the world of gaming!",
    },
    // aesexy: {
    //   redirectUrl: "/casino/aesexy",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: pageUrlGenerator("/home"),
    //   imgUrl: "./images/providers/aesexy.jpg",
    //   name: "AE Sexy",
    //   quotes:
    //     "Experience the thrill and elegance of AE Sexy, where every game is a captivating adventure, and every win adds a touch of allure. Join us for unforgettable moments!",
    // },
    powergames: {
      redirectUrl: "/casino/powergames",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/providers/powergames.jpg",
      name: "Power Games",
      quotes:
        "Unleash your potential and experience the thrill of winning at Power Games Casino, where every game is a new adventure and every spin brings you closer to your next big win!",
    },
  },
  slotsgames: {
    SerengetiKings: {
      redirectUrl: "/casino/ezgne-secrets-of-atlantis",
      code: "1100121                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/SerengetiKings.webp",
      alt: "",
      name: "Serengeti Kings",
      providerName: "NetEnt",
    },
    SpaceWars: {
      redirectUrl: "/casino/ezgne-space-wars",
      code: "1100122                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/spacewars.webp",
      alt: "",
      name: "Space Wars",
      providerName: "NetEnt",
    },
    Victorious: {
      redirectUrl: "/casino/ezgne-victorious",
      code: "1100123                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/Victorious.webp",
      alt: "",
      name: "Victorious",
      providerName: "NetEnt",
    },
    Warlords: {
      redirectUrl: "/casino/ezgne-warlords-crystal-of-power",
      code: "1100125                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/warlords.webp",
      alt: "",
      name: "Warlords: Crystal of Power",
      providerName: "NetEnt",
    },
    WildWater: {
      redirectUrl: "/casino/ezgne-wild-water",
      code: "1100126                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/WildWater.webp",
      alt: "",
      name: "Wild Water",
      providerName: "NetEnt",
    },
    WildWorlds: {
      redirectUrl: "/casino/ezgne-wild-worlds",
      code: "1100127                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/wildworlds.webp",
      alt: "",
      name: "Wild Worlds",
      providerName: "NetEnt",
    },
    Squad4: {
      redirectUrl: "/casino/ezgrt-4-squad",
      code: "1100129                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/Squad4.webp",
      alt: "",
      name: "4 Squad",
      providerName: "Red Tiger",
    },
    Families5: {
      redirectUrl: "/casino/ezgrt-5-families",
      code: "1100130                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/families5.webp",
      alt: "",
      name: "5 Families",
      providerName: "Red Tiger",
    },
    AgentRoyale: {
      redirectUrl: "/casino/ezgrt-agent-royale",
      code: "1100131                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/AgentRoyale.webp",
      alt: "",
      name: "Agent Royale",
      providerName: "Red Tiger",
    },
    ArcadeBomb: {
      redirectUrl: "/casino/ezgrt-arcade-bomb",
      code: "1100132                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/arcadebomb.webp",
      alt: "",
      name: "Arcade Bomb",
      providerName: "Red Tiger",
    },
    Atlantis: {
      redirectUrl: "/casino/ezgrt-atlantis",
      code: "1100133                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/Atlantis.webp",
      alt: "",
      name: "Atlantis",
      providerName: "Red Tiger",
    },
    AztecSpins: {
      redirectUrl: "/casino/ezgrt-aztec-spins",
      code: "1100134                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/aztecspins.webp",
      alt: "",
      name: "Aztec Spins",
      providerName: "Red Tiger",
    },
    CinderellaBall: {
      redirectUrl: "/casino/ezgrt-cinderellas-ball",
      code: "1100135                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/CinderellaBall.webp",
      alt: "",
      name: "Cinderella`s Ball",
      providerName: "Red Tiger",
    },
    CirquedelaFortune: {
      redirectUrl: "/casino/ezgrt-cirque-de-la-fortune",
      code: "1100136                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/CirquedelaFortune.webp",
      alt: "",
      name: "Cirque de la Fortune",
      providerName: "Red Tiger",
    },
    ClashoftheBeasts: {
      redirectUrl: "/casino/ezgrt-clash-of-the-beasts",
      code: "1100137                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/ClashoftheBeasts.webp",
      alt: "",
      name: "Clash of the Beasts",
      providerName: "Red Tiger",
    },
    CrazyGenie: {
      redirectUrl: "/casino/ezgrt-crazy-genie",
      code: "1100138                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/CrazyGenie.webp",
      alt: "",
      name: "Crazy Genie",
      providerName: "Red Tiger",
    },
    CrystalMirror: {
      redirectUrl: "/casino/ezgrt-crystal-mirror",
      code: "1100139                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/CrystalMirror.webp",
      alt: "",
      name: "Crystal Mirror",
      providerName: "Red Tiger",
    },
    DaVinciMystery: {
      redirectUrl: "/casino/ezgrt-da-vincis-mystery",
      code: "1100140                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/DaVinciMystery.webp",
      alt: "",
      name: "Da Vinci`s Mystery",
      providerName: "Red Tiger",
    },
    DevilNumber: {
      redirectUrl: "/casino/ezgrt-devils-number",
      code: "1100141                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/devilnumber.webp",
      alt: "",
      name: "Devil`s Number",
      providerName: "Red Tiger",
    },
    DiceDice: {
      redirectUrl: "/casino/ezgrt-dice-dice-dice",
      code: "1100142                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/DiceDice.webp",
      alt: "",
      name: "Dice Dice Dice",
      providerName: "Red Tiger",
    },
    FiveStarsPowerReels: {
      redirectUrl: "/casino/ezgrt-five-stars-power-reels",
      code: "1100144                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/FiveStarpowerreel.webp",
      alt: "",
      name: "Five Stars Power Reels",
      providerName: "Red Tiger",
    },
    GemsGoneWild: {
      redirectUrl: "/casino/ezgrt-gems-gone-wild",
      code: "1100145                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/GemsGoneWild.webp",
      alt: "",
      name: "Gems Gone Wild",
      providerName: "Red Tiger",
    },
    GemsGoneWildPowerReels: {
      redirectUrl: "/casino/ezgrt-gems-gone-wild-power-reels",
      code: "1100146                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/GemsGoneWildPowerReels.webp",
      alt: "",
      name: "Gems Gone Wild Power Reels",
      providerName: "Red Tiger",
    },
    GoldenLeprechaunMegaways: {
      redirectUrl: "/casino/ezgrt-golden-leprechaun-megaways",
      code: "1100148                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/GoldenLeprechaunMegaways.webp",
      alt: "",

      name: "Golden Leprechaun Megaways",
      providerName: "Red Tiger",
    },
    HoardofPoseidon: {
      redirectUrl: "/casino/ezgrt-hoard-of-poseidon",
      code: "1100151                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/HoardofPoseidon.webp",
      alt: "",
      name: "Hoard of Poseidon",
      providerName: "Red Tiger",
    },
    JewelScarabs: {
      redirectUrl: "/casino/ezgrt-jewel-scarabs",
      code: "1100152                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/JewelScarabs.webp",
      alt: "",
      name: "Jewel Scarabs",
      providerName: "Red Tiger",
    },
    JingleBellsPowerReels: {
      redirectUrl: "/casino/ezgrt-jingle-bells-power-reels",
      code: "1100153                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/JingleBellsPowerReels.webp",
      alt: "",
      name: "Jingle Bells Power Reels",
      providerName: "Red Tiger",
    },
    LegendofAthena: {
      redirectUrl: "/casino/ezgrt-legend-of-athena",
      code: "1100154                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/LegendofAthena.webp",
      alt: "",
      name: "Legend of Athena",
      providerName: "Red Tiger",
    },
    LuckyHalloween: {
      redirectUrl: "/casino/ezgrt-lucky-halloween",
      code: "1100155                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/LuckyHalloween.webp",
      alt: "",
      name: "Lucky Halloween",
      providerName: "Red Tiger",
    },
    LuckyLittleDevil: {
      redirectUrl: "/casino/ezgrt-lucky-little-devil",
      code: "1100156                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         ",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/slots/LuckyLittleDevil.webp",
      alt: "",
      name: "Lucky Little Devil",
      providerName: "Red Tiger",
    },
  },

  trending: {
    WorliMatka8: {
      href: "/casino/aggaproyalgaming-worli-matka-u3706",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/WorliMatka.webp",
      alt: "WorliMatka",
      name: "Worli Matka",
    },
    WorliMatka: {
      href: "/casino/aggapmac88gaming-worli-matka",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/WorliMatka-mac88.webp",
      alt: "WorliMatka-mac88",
      name: "Worli Matka",
    },
    cockfight: {
      href: "/casino/awc-cock-fight-phi",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/cockfight.webp",
      alt: "cockfight",
      name: "Cock fight",
    },
    Rummy: {
      href: "/casino/aggapjiligaming-rummy-u7364",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/Rummy.webp",
      alt: "Rummy",
      name: "Rummy",
    },
    PoolRummy: {
      href: "/casino/aggapjiligaming-pool-rummy",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/PoolRummy.webp",
      alt: "PoolRummy",
      name: "Pool Rummy",
    },
    ThreeCardRummy: {
      href: "/casino/aggapbetsoft-three-card-rummy",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/ThreeCardRummy.webp",
      alt: "ThreeCardRummy",
      name: "Three Card Rummy",
    },
    CrazyTime: {
      href: "/casino/ezgevo-crazy-time",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/CrazyTime.webp",
      alt: "Crazy Time",
      name: "Crazy Time",
    },
    ColorPrediction: {
      href: "/casino/aggapjiligaming-color-prediction",
      code: "",
      casino: "Jili",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/ColorPrediction.webp",
      alt: "Color Prediction",
      name: "Color Prediction",
    },

    DreamWheel: {
      href: "/casino/aggapmac88gaming-dream-wheel",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/DreamWheel.webp",
      alt: "Dream Wheel",
      name: "Dream Wheel",
    },
    Aviator: {
      href: "/casino/spribe-aviator",
      code: "",
      casino: "spribe",
      provider: "spribe",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/Aviator.webp",
      alt: "Aviator",
      name: "Aviator",
    },
    FootballStudio: {
      href: "/casino/ezgevo-football-studio",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/FootballStudio.webp",
      alt: "Football Studio",
      name: "Football Studio",
    },
    MarbelRaceMonaco: {
      href: "/casino/ezg-ez-marble-race-monaco",
      code: "",
      casino: "Ezugi",
      provider: "WorldCasino",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/ezmarbleracemon.webp",
      alt: "Marbel Race Monaco",
      name: "Marbel Race Monaco",
    },
    
    // MarbleRace: {
    //   href: "/casino/aggapevolutiongaming-marble-race",
    //   code: "",
    //   casino: "Evolution",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: pageUrlGenerator("/home"),
    //   imgUrl: "./images/casino-home/trending/MarbleRace.webp",
    //   alt: "Marble Race",
    //   name: "Marble Race",
    // },
    Mines: {
      href: "/casino/spribe/mines",
      code: "",
      casino: "Spribe",
      provider: "Spribe",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/Mines.webp",
      alt: "Mines",
      name: "Mines",
    },
    BollywoodKiss: {
      href: "/casino/aggapmac88gamingvirtual-bolly-kiss",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/BollywoodKiss.webp",
      alt: "Bollywood Kiss",
      name: "Bollywood Kiss",
    },
    Crash: {
      href: "/casino/aggapcrash88gaming-crash",
      code: "",
      casino: "CRASH88",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/Crash.webp",
      alt: "Crash",
      name: "Crash",
    },
    Diamonds: {
      href: "/casino/aggapmac88gamingvirtual-diamonds",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/Diamonds.webp",
      alt: "Diamonds",
      name: "Diamonds",
    },
    Dice: {
      href: "/casino/spribe/dice",
      code: "",
      casino: "Spribe",
      provider: "Spribe",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/Dice.webp",
      alt: "Dice",
      name: "Dice",
    },
    Limbo: {
      href: "/casino/aggapmac88gamingvirtual-limbo",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/Limbo.webp",
      alt: "Limbo",
      name: "Limbo",
    },
    Plinko: {
      href: "/casino/spribe/plinko",
      code: "",
      casino: "Spribe",
      provider: "Spribe",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/trending/Plinko.webp",
      alt: "Plinko",
      name: "Plinko",
    },
  },
  recommended: {
    BetonTeenPatti: {
      redirectUrl: "/casino/ezg-bet-on-teen-patti",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/Betonteenpatti1.webp",
      alt: "Bet on Teen Patti",
      name: "Bet on Teen Patti",
    },
    DragonTigerRec: {
      redirectUrl: "/casino/ezg-dragon-tiger",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/aura/Dragon-Tiger-Ezg.webp",
      alt: "dragon tiger 1",
      name: "Dragon Tiger 1",
    },
    Lucky7Rec: {
      redirectUrl: "/casino/ezg-lucky-7",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/lucky7.webp",
      alt: "seven lucky",
      name: "Seven Lucky",
    },
    ThreeCardPoker: {
      redirectUrl: "/casino/ezg-teen-patti-3-card",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/3cardteenpatti.webp",
      alt: "Three Card Poker and Teen Patti",
      name: "Three Card Poker and Teen Patti",
    },
    BaccaratARec: {
      redirectUrl: "/casino/ezgevo-baccarat-a",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/BaccaratAEvo.webp",
      alt: "baccarat a",
      name: "Baccarat A",
    },
    DreamCatcherAura: {
      code: "67564",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poker",
      name: "Poker",
      providerName: "aura",
      imgUrl: "./images/aura/dreamcatcher-Aura.webp",
      redirectUrl: "/casino/aura-dream-catcher",
    },
    RNG3PlayerTeenPatti: {
      redirectUrl: "/casino/sn-rng-3-player-teen-patti",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/RNG3PlayerTeenPatti1.webp",
      alt: "RNG 3 Player Teen Patti",
      name: "RNG 3 Player Teen Patti",
    },
    Hilow: {
      code: "67564",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hi Low",
      name: "Hi Low",
      providerName: "aura",
      imgUrl: "./images/aura/hilow-Aura.webp",
      redirectUrl: "/casino/aura-hi-low",
    },
    OneDayTeenPattiRec: {
      redirectUrl: "/casino/ezg-one-day-teen-patti",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/onedayteenpatti1.webp",
      alt: "one day teen patti",
      name: "One Day Teen Patti",
    },
    DragonTigerEvoRec: {
      redirectUrl: "/casino/ezgevo-dragon-tiger-evo",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/DragonTigerEvo.webp",
      alt: "dragon tiger evo",
      name: "Dragon Tiger Evo",
    },
    PokerRec: {
      code: "67564",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poker",
      name: "Poker",
      providerName: "aura",
      imgUrl: "./images/aura/Poker-Aura.webp",
      redirectUrl: "/casino/aura-poker",
    },
    RNGTeenPatti: {
      redirectUrl: "/casino/sn-rng-teen-patti",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/RNGTeenPatti1.webp",
      alt: "RNG Teen Patti",
      name: "RNG Teen Patti",
    },
    MatkaRec: {
      code: "92037",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Matka",
      name: "Matka",
      providerName: "aura",
      imgUrl: "./images/aura/Matka-Aura.webp",
      redirectUrl: "/casino/aura-matka",
    },
    RNGTeenPatti2020: {
      redirectUrl: "/casino/sn-rng-teen-patti-2020",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/RNGTeenPatti2020-New.webp",
      alt: "RNG Teen Patti 2020",
      name: "RNG Teen Patti 2020",
    },
    BaccaratRec: {
      code: "92038",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat",
      name: "Baccarat",
      providerName: "aura",
      imgUrl: "./images/aura/Baccarat-Aura.webp",
      redirectUrl: "/casino/aura-baccarat",
    },
    TeenPatti: {
      redirectUrl: "/casino/sn-teen-patti",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/TeenPatti1.webp",
      alt: "TeenPatti",
      name: "TeenPatti",
    },
    Raceto17Rec: {
      code: "67710",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Race to 17",
      name: "Race to 17",
      providerName: "aura",
      imgUrl: "./images/aura/Raceto17-Aura.webp",
      redirectUrl: "/casino/aura-race-to-17",
    },
    TeenPatti2020: {
      redirectUrl: "/casino/sn-teen-patti-2020",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/teenpatti2020.webp",
      alt: "TeenPatti 2020",
      name: "TeenPatti 2020",
    },
    PokerAuraRec: {
      code: "67564",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poker",
      name: "Poker",
      providerName: "aura",
      imgUrl: "./images/aura/Poker-Aura.webp",
      redirectUrl: "/casino/aura-poker",
    },
    SuperOverAuraRec: {
      code: "67720",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Over",
      name: "Super Over",
      providerName: "aura",
      imgUrl: "./images/aura/SuperOver-Aura.webp",
      redirectUrl: "/casino/aura-sper-over",
    },
    TeenPattiFaceOff: {
      redirectUrl: "/casino/sn-teen-patti-face-off",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/TeenPattiFaceOff1.webp",
      alt: "Teen Patti Face Off",
      name: "Teen Patti Face Off",
    },
    SixplayerpokerRec: {
      code: "67565",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Six player poker",
      name: "Six player poker",
      providerName: "aura",
      imgUrl: "./images/aura/Sixplayerpoker-Aura.webp",
      redirectUrl: "/casino/aura-six-player-poker",
    },
    AndarBaharLiveRec: {
      redirectUrl: "/casino/ezg-andar-bahar",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/andarbahar.webp",
      alt: "andar bahar live",
      name: "Andar Bahar Lve",
    },
    Cards32Rec: {
      redirectUrl: "/casino/ezg-32-cards",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/32cards.webp",
      alt: "32 cards",
      name: "32 Cards",
    },
    SuperOverRec: {
      code: "67720",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Over",
      name: "Super Over",
      providerName: "aura",
      imgUrl: "./images/aura/SuperOver-Aura.webp",
      redirectUrl: "/casino/aura-sper-over",
    },
    TrioRec: {
      code: "67610",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Trio",
      name: "Trio",
      providerName: "aura",
      imgUrl: "./images/aura/Trio-new-Aura.webp",
      redirectUrl: "/casino/aura-trio",
    },
    CardsJudgement3Rec: {
      code: "67670",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Cards Judgement",
      name: "3 Cards Judgement",
      providerName: "aura",
      imgUrl: "./images/aura/3CardJudgement-Aura.webp",
      redirectUrl: "/casino/aura-3-cards-judgement",
    },
    Race2020Rec: {
      code: "90100",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Race 20-20",
      name: "Race 20-20",
      providerName: "aura",
      imgUrl: "./images/aura/Race20-20-Aura.webp",
      redirectUrl: "/casino/aura-race-20-20",
    },
    CardBaccarat29Rec: {
      code: "67690",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "29 Card Baccarat",
      name: "29 Card Baccarat",
      providerName: "aura",
      imgUrl: "./images/aura/CardBaccarat29-Aura.webp",
      redirectUrl: "/casino/aura-29-card-baccarat",
    },
    TeenpattiOpenRec: {
      code: "67640",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti Open",
      name: "Teenpatti Open",
      providerName: "aura",
      imgUrl: "./images/aura/teenpaatiopen-Aura.webp",
      redirectUrl: "/casino/aura-teenpatti-open",
    },
    CasinoMeterRec: {
      code: "67575",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Casino Meter",
      name: "Casino Meter",
      providerName: "aura",
      imgUrl: "./images/aura/CasinoMeter-Aura.webp",
      redirectUrl: "/casino/aura-casino-meter",
    },
    TheTrapRec: {
      code: "67680",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Trap",
      name: "The Trap",
      providerName: "aura",
      imgUrl: "./images/aura/TheTrap-Aura.webp",
      redirectUrl: "/casino/aura-the-trap",
    },
    BaccaratAuraRec: {
      redirectUrl: "/casino/aura-baccarat",
      code: "",
      casino: "Aura Gaming",
      provider: "Aura",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/aura/Baccarat-Aura.webp",
      alt: "baccarat",
      name: "Baccarat",
    },
    MatkaAuraRec: {
      redirectUrl: "/casino/aura-matka",
      code: "",
      casino: "Aura Gaming",
      provider: "Aura",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/aura/Matka-Aura.webp",
      alt: "matka",
      name: "Matka",
    },
    TrioAuraRec: {
      redirectUrl: "/casino/aura-trio",
      code: "",
      casino: "Aura Gaming",
      provider: "Aura",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/aura/Trio-new-Aura.webp",
      alt: "trio",
      name: "Trio",
    },
    TeenpattiT20AuraRec: {
      code: "56768",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti T20",
      name: "Teenpatti T20",
      providerName: "aura",
      imgUrl: "./images/aura/TeenpattiT20-Aura.webp",
      redirectUrl: "/casino/aura-teenpatti-t20",
    },
    DragonTigerAuraRec: {
      code: "98790",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
      providerName: "aura",
      imgUrl: "./images/aura/Dragon-Tiger-Aura.webp",
      redirectUrl: "/casino/aura-dragon-tiger",
    },
    MatkaAuraRec: {
      code: "92037",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Matka",
      name: "Matka",
      providerName: "aura",
      imgUrl: "./images/aura/Matka-Aura.webp",
      redirectUrl: "/casino/aura-matka",
    },
    BaccaratAuraRec: {
      code: "92038",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat",
      name: "Baccarat",
      providerName: "aura",
      imgUrl: "./images/aura/Baccarat-Aura.webp",
      redirectUrl: "/casino/aura-baccarat",
    },
    TrioAuraRec: {
      code: "67610",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Trio",
      name: "Trio",
      providerName: "aura",
      imgUrl: "./images/aura/Trio-new-Aura.webp",
      redirectUrl: "/casino/aura-trio",
    },
    CardsJudgement3AuraRec: {
      code: "67670",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Cards Judgement",
      name: "3 Cards Judgement",
      providerName: "aura",
      imgUrl: "./images/aura/3CardJudgement-Aura.webp",
      redirectUrl: "/casino/aura-3-cards-judgement",
    },
    Race2020AuraRec: {
      code: "90100",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Race 20-20",
      name: "Race 20-20",
      providerName: "aura",
      imgUrl: "./images/aura/Race20-20-Aura.webp",
      redirectUrl: "/casino/aura-race-20-20",
    },
    CardBaccarat29AuraRec: {
      code: "67690",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "29 Card Baccarat",
      name: "29 Card Baccarat",
      providerName: "aura",
      imgUrl: "./images/aura/CardBaccarat29-Aura.webp",
      redirectUrl: "/casino/aura-29-card-baccarat",
    },
    TeenpattiOpenAuraRec: {
      code: "67640",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti Open",
      name: "Teenpatti Open",
      providerName: "aura",
      imgUrl: "./images/aura/teenpaatiopen-Aura.webp",
      redirectUrl: "/casino/aura-teenpatti-open",
    },
    Raceto17AuraRec: {
      code: "67710",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Race to 17",
      name: "Race to 17",
      providerName: "aura",
      imgUrl: "./images/aura/Raceto17-Aura.webp",
      redirectUrl: "/casino/aura-race-to-17",
    },
    SixplayerpokerAuraRec: {
      code: "67565",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Six player poker",
      name: "Six player poker",
      providerName: "aura",
      imgUrl: "./images/aura/Sixplayerpoker-Aura.webp",
      redirectUrl: "/casino/aura-six-player-poker",
    },
    CasinoMeterAuraRec: {
      code: "67575",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Casino Meter",
      name: "Casino Meter",
      providerName: "aura",
      imgUrl: "./images/aura/CasinoMeter-Aura.webp",
      redirectUrl: "/casino/aura-casino-meter",
    },
    TheTrapAuraRec: {
      code: "67680",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Trap",
      name: "The Trap",
      providerName: "aura",
      imgUrl: "./images/aura/TheTrap-Aura.webp",
      redirectUrl: "/casino/aura-the-trap",
    },
  },
  liveCasino: {
    SuperAndarBhar: {
      href: "/casino/aggapevolutiongaming-super-andar-bahar-u6070",
      code: "",
      casino: "Ezugi",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/livecasino/SuperAndarBahar.jpg",
      alt: "Super Andar Bahar",
      name: "Super Andar Bahar",
    },
    UltimateRoulette: {
      href: "/casino/ezg-ultimate-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/livecasino/UltimateRoulette.webp",
      alt: "Ultimate Roulette",
      name: "Ultimate Roulette",
    },
    AutoRoulette: {
      href: "/casino/ezgevo-speed-auto-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/livecasino/AutoRoulette.webp",
      alt: "Auto Roulette",
      name: "Auto Roulette",
    },
    CasinoHoldem: {
      href: "/casino/ezgevo-2-hand-casino-holdem",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/livecasino/CasinoHoldem.webp",
      alt: "Casino Holde'm",
      name: "Casino Holde'm",
    },
    CrazyTime: {
      href: "/casino/ezgevo-crazy-time",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/livecasino/CrazyTime.webp",
      alt: "Crazy Time",
      name: "Crazy Time",
    },
    DragonTiger: {
      href: "/casino/ezgevo-dragon-tiger-evo",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/livecasino/DragonTiger.webp",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
    },
    LightningDice: {
      href: "/casino/ezgevo-lightning-dice",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/livecasino/LightningDice.webp",
      alt: "Lightning Dice",
      name: "Lightning Dice",
    },
    LightningRoulette: {
      href: "/casino/ezgevo-lightning-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/livecasino/LightningRoulette.webp",
      alt: "Lightning Roulette",
      name: "Lightning Roulette",
    },
    RedDoorRoulette: {
      href: "/casino/ezgevo-red-door-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/livecasino/RedDoorRoulette.webp",
      alt: "Red Door Roulette",
      name: "Red Door Roulette",
    },
    SpeedBaccaratA: {
      href: "/casino/ezgevo-speed-baccarat-a",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/livecasino/speedbaccarat.webp",
      alt: "Speed Baccarat A",
      name: "Speed Baccarat A",
    },
    SuperSicBo: {
      href: "/casino/ezgevo-super-sic-bo",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/livecasino/SuperSicBo.webp",
      alt: "Super Sic Bo",
      name: "Super Sic Bo",
    },
    XxxtremeLightningRoulette: {
      href: "/casino/ezgevo-xxxtreme-lightning-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino-home/livecasino/XxxtremeLightningRoulette.webp",
      alt: "Xxxtreme Lightning Roulette",
      name: "Xxxtreme Lightning Roulette",
    },
  },
  playNGo: {
    BookOfDead: {
      href: "/casino/aggapplayngo-book-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/play-n-go/BookofDead.webp",
      alt: "book of dead",
      name: "Book of Dead",
    },
    LegacyOfDead: {
      href: "/casino/aggapplayngo-legacy-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/play-n-go/LegacyOfDead.webp",
      alt: "Legacy of Dead",
      name: "Legacy of Dead",
    },
    RiseOfOlympus100: {
      href: "/casino/aggapplayngo-rise-of-olympus-100",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/play-n-go/RiseOfOlympus100.webp",
      alt: "Rise of Olympus 100",
      name: "Rise of Olympus 100",
    },
    MoonPrincess: {
      href: "/casino/aggapplayngo-moon-princess",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/play-n-go/MoonPrincess.webp",
      alt: "Moon Princess",
      name: "Moon Princess",
    },
    Reactoonz: {
      href: "/casino/aggapplayngo-reactoonz",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/play-n-go/Reactoonz.webp",
      alt: "Reactoonz",
      name: "Reactoonz",
    },
    Reactoonz2: {
      href: "/casino/aggapplayngo-reactoonz-2",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/play-n-go/Reactoonz2.webp",
      alt: "Reactoonz 2",
      name: "Reactoonz 2",
    },
    AliceCooperAndTheTomeOfMadness: {
      href: "/casino/aggapplayngo-alice-cooper-and-the-tome-of-madness",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl:
        "./images/casino-home/play-n-go/AliceCooperAndTheTomeOfMadness.webp",
      alt: "Alice Cooper And The Tome Of Madness",
      name: "Alice Cooper And The Tome Of Madness",
    },
    FireJoker: {
      href: "/casino/aggapplayngo-fire-joker",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/play-n-go/FireJoker.webp",
      alt: "Fire Joker",
      name: "Fire Joker",
    },
    DiamondVortex: {
      href: "/casino/aggapplayngo-diamond-vortex",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/play-n-go/DiamondVortex.webp",
      alt: "diamond-vortex",
      name: "Diamond Vortex",
    },
    GoldenTicket: {
      href: "/casino/aggapplayngo-golden-ticket",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/play-n-go/GoldenTicket.webp",
      alt: "Golden Ticket",
      name: "Golden Ticket",
    },
    LordMerlinAndTheLadyOfTheLake: {
      href: "/casino/aggapplayngo-lord-merlin-and-the-lady-of-the-lake",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl:
        "./images/casino-home/play-n-go/LordMerlinAndTheLadyOfTheLake.webp",
      alt: "Lord Merlin and The Lady of The Lake",
      name: "Lord Merlin and The Lady of The Lake",
    },
    HugoLegacy: {
      href: "/casino/aggapplayngo-hugo-legacy",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/play-n-go/HugoLegacy.webp",
      alt: "hugo legacy",
      name: "Hugo Legacy",
    },
    Sabaton: {
      href: "/casino/aggapplayngo-sabaton",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/play-n-go/Sabaton.webp",
      alt: "Sabaton",
      name: "Sabaton",
    },
    AnimalMadness: {
      href: "/casino/aggapplayngo-animal-madness",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/play-n-go/AnimalMadness.webp",
      alt: "animal madness",
      name: "Animal Madness",
    },
    // BattleRoyal: {
    //   href: "/casino/aggapplayngo-battle-royal",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/play-n-go/BattleRoyal.webp",
    //   alt: "battle royal",
    //   name: "Battle Royal",
    // },
  },
  habanero: {
    HotHotFruit: {
      href: "/casino/qt-hot-hot-fruit",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/habanero/HotHotFruit.webp",
      alt: "Hot Hot Fruit",
      name: "Hot Hot Fruit",
    },
    Lucky5Lions: {
      href: "/casino/qt-5-lucky-lions",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/habanero/5LuckyLions.webp",
      alt: "5 Lucky Lions",
      name: "5 Lucky Lions",
    },
    KoiGate: {
      href: "/casino/qt-koi-gate",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/habanero/KoiGate.webp",
      alt: "Koi Gate",
      name: "Koi Gate",
    },
    EgyptianDreamsDeluxe: {
      href: "/casino/qt-egyptian-dreams-deluxe",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/habanero/EgyptianDreamsDeluxe.webp",
      alt: "Egyptian Dreams Deluxe",
      name: "Egyptian Dreams Deluxe",
    },
    SantasVillage: {
      href: "/casino/qt-santas-village",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/habanero/SantasVillage.webp",
      alt: "Santa’s Village",
      name: "Santa’s Village",
    },
    FaCaiShen: {
      href: "/casino/qt-fa-cai-shen",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/habanero/FaCaiShen.webp",
      alt: "Fa Cai Shen",
      name: "Fa Cai Shen",
    },
    BirdOfThunder: {
      href: "/casino/qt-bird-of-thunder",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/habanero/BirdofThunder.webp",
      alt: "Bird of Thunder",
      name: "Bird of Thunder",
    },
    FourDivineBeasts: {
      href: "/casino/qt-four-divine-beasts",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/habanero/FourDivineBeasts.webp",
      alt: "Four Divine Beasts",
      name: "Four Divine Beasts",
    },
    MountMazuma: {
      href: "/casino/qt-mount-mazuma",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/habanero/MountMazuma.webp",
      alt: "Mount Mazuma",
      name: "Mount Mazuma",
    },
    Presto: {
      href: "/casino/qt-presto",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/habanero/Presto.webp",
      alt: "Presto",
      name: "Presto",
    },
    RollingRoger: {
      href: "/casino/qt-rolling-roger",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/habanero/RollingRoger.webp",
      alt: "Rolling Roger",
      name: "Rolling Roger",
    },
    PumpkinPatch: {
      href: "/casino/qt-pumpkin-patch",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/habanero/PumpkinPatch.webp",
      alt: "Pumpkin Patch",
      name: "Pumpkin Patch",
    },
    ColossalGems: {
      href: "/casino/qt-colossal-gems",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/habanero/ColossalGems.webp",
      alt: "Colossal Gems",
      name: "Colossal Gems",
    },
    OrbsOfAtlantis: {
      href: "/casino/qt-orbs-of-atlantis",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/habanero/OrbsOfAtlantis.webp",
      alt: "Orbs Of Atlantis",
      name: "Orbs Of Atlantis",
    },
    // ArcaneElements: {
    //   href: "/casino/qt-arcane-elements",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "WorldCasino",
    //   category: "habanero",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/habanero/ArcaneElements.webp",
    //   alt: "Arcane Elements",
    //   name: "Arcane Elements",
    // },
  },
  dragoonSoft: {
    Golf: {
      href: "/casino/aggapdrgs-golf",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/dragoon-soft/Golf.webp",
      alt: "Golf",
      name: "Golf",
    },
    GrandSheriff: {
      href: "/casino/aggapdrgs-grand-sheriff",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/dragoon-soft/GrandSheriff.webp",
      alt: "Grand Sheriff",
      name: "Grand Sheriff",
    },
    GreatLion: {
      href: "/casino/aggapdrgs-great-lion",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/dragoon-soft/GreatLion.webp",
      alt: "Great Lion",
      name: "Great Lion",
    },
    FruitsBar: {
      href: "/casino/aggapdrgs-fruits-bar",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/dragoon-soft/FruitsBar.webp",
      alt: "Fruits Bar",
      name: "Fruits Bar",
    },
    JinHouYe: {
      href: "/casino/aggapdrgs-jin-hou-ye",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/dragoon-soft/JinHouYe.webp",
      alt: "Jin Hou Ye",
      name: "Jin Hou Ye",
    },
    RichLion: {
      href: "/casino/aggapdrgs-rich-lion",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/dragoon-soft/RichLion.webp",
      alt: "Rich Lion",
      name: "Rich Lion",
    },
    Roman: {
      href: "/casino/aggapdrgs-roman",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/dragoon-soft/Roman.webp",
      alt: "Roman",
      name: "Roman",
    },
    Zeus: {
      href: "/casino/aggapdrgs-zeus",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/dragoon-soft/Zeus.webp",
      alt: "Zeus",
      name: "Zeus",
    },
    GoldenEgg: {
      href: "/casino/aggapdrgs-golden-egg",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/dragoon-soft/GoldenEgg.webp",
      alt: "Golden Egg",
      name: "Golden Egg",
    },
    BengalTiger: {
      href: "/casino/aggapdrgs-bengal-tiger",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/dragoon-soft/BengalTiger.webp",
      alt: "Bengal Tiger",
      name: "Bengal Tiger",
    },
    BonusCat: {
      href: "/casino/aggapdrgs-bonus-cat",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/dragoon-soft/BonusCat.webp",
      alt: "Bonus Cat",
      name: "Bonus Cat",
    },
    Arab: {
      href: "/casino/aggapdrgs-arab",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/dragoon-soft/Arab.webp",
      alt: "Arab",
      name: "Arab",
    },
    DiamondMogul: {
      href: "/casino/aggapdrgs-diamond-mogul",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/dragoon-soft/DiamondMogul.webp",
      alt: "Diamond Mogul",
      name: "Diamond Mogul",
    },
    EgyptOracle: {
      href: "/casino/aggapdrgs-egypt-oracle",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/dragoon-soft/EgyptOracle.webp",
      alt: "Egypt Oracle",
      name: "Egypt Oracle",
    },
    // Pandaria: {
    //   href: "/casino/aggapdrgs-pandaria",
    //   code: "",
    //   casino: "Slots",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/dragoon-soft/Pandaria.webp",
    //   alt: "Pandaria",
    //   name: "Pandaria",
    // },
  },
  hacksaw: {
    ZeZeus: {
      href: "/casino/aggaphacksawgaming-ze-zeus",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/hacksaw/ZeZeus.webp",
      alt: "Ze Zeus",
      name: "Ze Zeus",
    },
    WarriorWays: {
      href: "/casino/aggaphacksawgaming-warrior-ways",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/hacksaw/WarriorWays.webp",
      alt: "Warrior Ways",
      name: "Warrior Ways",
    },
    TimeSpinners: {
      href: "/casino/aggaphacksawgaming-time-spinners",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/hacksaw/TimeSpinners.webp",
      alt: "Time Spinners",
      name: "Time Spinners",
    },
    RocketReels: {
      href: "/casino/aggaphacksawgaming-rocket-reels",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/hacksaw/RocketReels.webp",
      alt: "Rocket Reels",
      name: "Rocket Reels",
    },
    KeepemCool: {
      href: "/casino/aggaphacksawgaming-keepem-cool",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/hacksaw/KeepemCool.webp",
      alt: "Keep'em Cool",
      name: "Keep'em Cool",
    },
    Itero: {
      href: "/casino/aggaphacksawgaming-itero",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/hacksaw/Itero.webp",
      alt: "Itero",
      name: "Itero",
    },
    FranksFarm: {
      href: "/casino/aggaphacksawgaming-franks-farm",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/hacksaw/FranksFarm.webp",
      alt: "Frank's Farm",
      name: "Frank's Farm",
    },
    CashQuest: {
      href: "/casino/aggaphacksawgaming-cash-quest",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/hacksaw/CashQuest.webp",
      alt: "Cash Quest",
      name: "Cash Quest",
    },
    BuffaloStackNSync: {
      href: "/casino/aggaphacksawgaming-buffalo-stacknsync",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/hacksaw/BuffaloStackNSync.webp",
      alt: "Buffalo Stack'n'Sync",
      name: "Buffalo Stack'n'Sync",
    },
    Bloodthirst: {
      href: "/casino/aggaphacksawgaming-bloodthirst",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/hacksaw/Bloodthirst.webp",
      alt: "Bloodthirst",
      name: "Bloodthirst",
    },
    AlphaEagle: {
      href: "/casino/aggaphacksawgaming-alpha-eagle",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/hacksaw/AlphaEagle.webp",
      alt: "Alpha Eagle",
      name: "Alpha Eagle",
    },
    DarkSummoning: {
      href: "/casino/aggaphacksawgaming-dark-summoning",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/hacksaw/DarkSummoning.webp",
      alt: "Dark Summoning",
      name: "Dark Summoning",
    },
    XmasDrop: {
      href: "/casino/aggaphacksawgaming-xmas-drop",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/hacksaw/XmasDrop.webp",
      alt: "Xmas Drop",
      name: "Xmas Drop",
    },
    TigerScratch: {
      href: "/casino/aggaphacksawgaming-tiger-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/hacksaw/TigerScratch.webp",
      alt: "Tiger Scratch",
      name: "Tiger Scratch",
    },
    // Wild2Die2: {
    //   href: "/casino/aggaphacksawgaming-2-wild-2-die",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/hacksaw/2Wild2Die.webp",
    //   alt: "2 Wild 2 Die",
    //   name: "2 Wild 2 Die",
    // },
  },
  instantWin: {
    LuckyNumbersx12: {
      href: "/casino/qt-lucky-numbers-x12",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/LuckyNumbersx12.webp",
      alt: "Lucky Numbers x12",
      name: "Lucky Numbers x12",
      providerName: "WorldCasino",
    },
    LuckyNumbersx16: {
      href: "/casino/qt-lucky-numbers-x16",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/LuckyNumbersx16.webp",
      alt: "Lucky Numbers x16",
      name: "Lucky Numbers x16",
      providerName: "WorldCasino",
    },
    LuckyNumbersx20: {
      href: "/casino/qt-lucky-numbers-x20",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/LuckyNumbersx20.webp",
      alt: "Lucky Numbers x20",
      name: "Lucky Numbers x20",
      providerName: "WorldCasino",
    },
    BookOfPower: {
      href: "/casino/qt-book-of-power",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/BookOfPower.webp",
      alt: "Book Of Power",
      name: "Book Of Power",
      providerName: "WorldCasino",
    },
    CursedSeas: {
      href: "/casino/qt-cursed-seas",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/CursedSeas.webp",
      alt: "Cursed Seas",
      name: "Cursed Seas",
      providerName: "WorldCasino",
    },
    DogTownDeal: {
      href: "/casino/qt-dog-town-deal",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/DogTownDeal.webp",
      alt: "Dog Town Deal",
      name: "Dog Town Deal",
      providerName: "WorldCasino",
    },
    EForce: {
      href: "/casino/qt-e-force",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/EForce.webp",
      alt: "E-Force",
      name: "E-Force",
      providerName: "WorldCasino",
    },
    LeprechaunCharms: {
      href: "/casino/qt-leprechaun-charms",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/LeprechaunCharms.webp",
      alt: "Leprechaun Charms",
      name: "Leprechaun Charms",
      providerName: "WorldCasino",
    },
    MidasGoldenTouch: {
      href: "/casino/qt-midas-golden-touch",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/MidasGoldenTouch.webp",
      alt: "Midas Golden Touch",
      name: "Midas Golden Touch",
      providerName: "WorldCasino",
    },
    MoneyTrain2: {
      href: "/casino/qt-money-train-2",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/MoneyTrain2.webp",
      alt: "Money Train 2",
      name: "Money Train 2",
      providerName: "WorldCasino",
    },
    MoneyTrain3: {
      href: "/casino/qt-money-train-3",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/MoneyTrain3.webp",
      alt: "Money Train 3",
      name: "Money Train 3",
      providerName: "WorldCasino",
    },
    PlinkoGo: {
      href: "/casino/qt-plinko-go",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/PlinkoGo.webp",
      alt: "Plinko Go",
      name: "Plinko Go",
      providerName: "WorldCasino",
    },
    Ragnawolves: {
      href: "/casino/qt-ragnawolves",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/Ragnawolves.webp",
      alt: "Ragnawolves",
      name: "Ragnawolves",
      providerName: "WorldCasino",
    },
    RoyalPotato: {
      href: "/casino/qt-royal-potato",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/RoyalPotato.webp",
      alt: "Royal Potato",
      name: "Royal Potato",
      providerName: "WorldCasino",
    },
    SharkWash: {
      href: "/casino/qt-shark-wash",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/SharkWash.webp",
      alt: "Shark Wash",
      name: "Shark Wash",
      providerName: "WorldCasino",
    },
    Whacked: {
      href: "/casino/qt-whacked",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/Whacked.webp",
      alt: "Whacked!",
      name: "Whacked!",
      providerName: "WorldCasino",
    },
    WildChapo: {
      href: "/casino/qt-wild-chapo",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/WildChapo.webp",
      alt: "Wild Chapo",
      name: "Wild Chapo",
      providerName: "WorldCasino",
    },
    WildYield: {
      href: "/casino/qt-wild-yield",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/instant-win-qt/WildYield.webp",
      alt: "Wild Yield",
      name: "Wild Yield",
      providerName: "WorldCasino",
    },
  },
  crashGames: {
    Aviator: {
      href: "/casino/aggapmac88gamingvirtual-aviator-x",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/Aviator.webp",
      alt: "Aviator",
      name: "Aviator",
      providerName: "WorldCasino",
    },
    CricketX: {
      href: "/casino/aggapsmartsoftgaming-cricketx",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/Cricketx.webp",
      alt: "CricketX",
      name: "CricketX",
      providerName: "SmartSoft",
    },
    JetX: {
      href: "/casino/aggapsmartsoftgaming-jetx",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/Jet-X.webp",
      alt: "JetX",
      name: "JetX",
      providerName: "SmartSoft",
    },
    CabinCrashers: {
      href: "/casino/qt-cabin-crashers",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/CabinCrashers.webp",
      alt: "Cabin Crashers",
      name: "Cabin Crashers",
      providerName: "WorldCasino",
    },
    CashorCrash: {
      href: "/casino/qt-cash-or-crash",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/CashorCrash.webp",
      alt: "Cash or Crash",
      name: "Cash or Crash",
      providerName: "WorldCasino",
    },
    CoyoteCrash: {
      href: "/casino/qt-coyote-crash",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/CoyoteCrash.webp",
      alt: "Coyote Crash",
      name: "Coyote Crash",
      providerName: "WorldCasino",
    },
    CrashoutFirework: {
      href: "/casino/qt-crashout-firework",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/CrashoutFirework.webp",
      alt: "Crashout - Firework",
      name: "Crashout - Firework",
      providerName: "WorldCasino",
    },
    CrashX: {
      href: "/casino/qt-crashx",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/CrashX.webp",
      alt: "CrashX",
      name: "CrashX",
      providerName: "WorldCasino",
    },
    CrashXFootballEdition: {
      href: "/casino/qt-crashx-football-edition",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/CrashXFootballEdition.webp",
      alt: "CrashX Football Edition",
      name: "CrashX Football Edition",
      providerName: "WorldCasino",
    },
    FootballManager: {
      href: "/casino/qt-football-manager",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/FootballManager.webp",
      alt: "Football Manager",
      name: "Football Manager",
      providerName: "WorldCasino",
    },
    GemHunterCrash: {
      href: "/casino/qt-gem-hunter-crash",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/GemHunterCrash.webp",
      alt: "Gem Hunter Crash",
      name: "Gem Hunter Crash",
      providerName: "WorldCasino",
    },
    GoblinRun: {
      href: "/casino/qt-goblin-run",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/GoblinRun.webp",
      alt: "Goblin Run",
      name: "Goblin Run",
      providerName: "WorldCasino",
    },
    HighStriker: {
      href: "/casino/qt-high-striker",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/HighStriker.webp",
      alt: "High Striker",
      name: "High Striker",
      providerName: "WorldCasino",
    },
    JungleRun: {
      href: "/casino/qt-jungle-run",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/JungleRun.webp",
      alt: "Jungle Run",
      name: "Jungle Run",
      providerName: "WorldCasino",
    },
    LuckyCrumbling: {
      href: "/casino/qt-lucky-crumbling",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/LuckyCrumbling.webp",
      alt: "Lucky Crumbling",
      name: "Lucky Crumbling",
      providerName: "WorldCasino",
    },
    Maverick: {
      href: "/casino/qt-maverick",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/Maverick.webp",
      alt: "Maverick",
      name: "Maverick",
      providerName: "WorldCasino",
    },
    SpaceXY: {
      href: "/casino/qt-space-xy",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/crash-qt/SpaceXY.webp",
      alt: "Space XY",
      name: "Space XY",
      providerName: "WorldCasino",
    },
  },
  lottery: {
    BingoBillionLlamaCaleta: {
      href: "/casino/aggapcaletagaming-bingo-billion-llama",
      code: "",
      casino: "Caleta",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/lottery/BingoBillionLlama.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    FastKenoTVBet: {
      href: "/casino/aggaptvbet-fast-keno",
      code: "",
      casino: "TVBet",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/lottery/FastKeno.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    FootballLottoCaleta: {
      href: "/casino/aggapcaletagaming-football-lotto",
      code: "",
      casino: "Caleta",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/lottery/FootballLotto.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    HalloweenLottoCaleta: {
      href: "/casino/aggapcaletagaming-halloween-lotto",
      code: "",
      casino: "Caleta",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/lottery/HalloweenLotto.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    KenoTVBet: {
      href: "/casino/aggaptvbet-keno",
      code: "",
      casino: "TVBet",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/lottery/Keno.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    LotteryTableRoyal: {
      href: "/casino/aggaproyalgaming-lottery",
      code: "",
      casino: "royal gaming",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/lottery/Lottery.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    MagicIdolPopok: {
      href: "/casino/aggappopokinstant-magic-idol",
      code: "",
      casino: "Popok Instant",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/lottery/MagicIdol.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    // MegaBallEvo: {
    //   href: "/casino/aggapevolutiongaming-mega-ball-u6021",
    //   code: "",
    //   casino: "Evolution",
    //   provider: "ALT_GAMING_GAP",
    //   category: "lottery",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/lottery/MegaBall.webp",
    //   alt: "Lottery",
    //   name: "Lottery",
    // },
    // RedHotLinePopok: {
    //   href: "/casino/aggappopokinstant-red-hot-line",
    //   code: "",
    //   casino: "Popok Instant",
    //   provider: "ALT_GAMING_GAP",
    //   category: "lottery",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/lottery/RedHotLine.webp",
    //   alt: "Lottery",
    //   name: "Lottery",
    // },
    SpinStrikeTurbo: {
      href: "/casino/aggapturbogames-spin-strike",
      code: "",
      casino: "Turbo Games",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/lottery/SpinStrike.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    LotteryMac88: {
      href: "/casino/aggapmac88gaming-lottery",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/lottery/LotteryMac88.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    VRLotteryRoyal: {
      href: "/casino/aggaproyalgamingvirtual-vr-lottery",
      code: "",
      casino: "royal gaming",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/lottery/VRLottery.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    WheelHacksaw: {
      href: "/casino/aggaphacksawgaming-wheel",
      code: "",
      casino: "Hacksaw Gaming",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/lottery/Wheel.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    Wheel94Hacksaw: {
      href: "/casino/aggaphacksawgaming-wheel-92",
      code: "",
      casino: "Hacksaw Gaming",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/lottery/Wheel92.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    Wheel92Hacksaw: {
      href: "/casino/aggaphacksawgaming-wheel-94",
      code: "",
      casino: "Hacksaw Gaming",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/lottery/Wheel94.webp",
      alt: "Lottery",
      name: "Lottery",
    },
  },
};
